<template>
  <div
    id="vendor-assess-questions"
    class="tw-flex-1 tw-flex tw-flex-col tw-min-w-full tw-max-w-[1060px]"
  >
    <AssessmentCategoryHeader
      :title="
        getComponentUiText(
          'app-assess-recommendations-section-assessment-questions-1',
        )
      "
      class="tw-mb-[20px]"
    />

    <div
      :class="`tw-flex tw-w-full tw-justify-between tw-flex-col md:tw-flex-row tw-gap-[20px] ${
        questionList[0]?.type === VENDOR_QUESTION_RENDER_TYPE.question
          ? 'tw-mb-[40px]'
          : ''
      }`"
    >
      <div>
        <BaseSearchbox
          :id="`vendor-question-create-page-input-search`"
          :class="[
            'tw-w-[-webkit-fill-available] tw-max-w-[449px] tw-relative tw-h-[44px] tw-rounded-[6px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#ffffff] tw-pt-[10px] tw-pb-[8px] tw-px-[15px] tw-mr-[20px]',
          ]"
          :model-value="valueSearch"
          :placeholder="getComponentUiText('app-header-search-prompt-1')"
          :input-search="`vendor-assess-template-search-box`"
          @update:model-value="onChangeValueSearch"
          @on:focus="() => {}"
          @on:blur="() => {}"
          @keyup.enter="() => {}"
        />
      </div>
      <div id="assess-view-toggle" class="tw-flex tw-flex-wrap">
        <div
          class="tw-flex tw-flex-wrap md:tw-items-center md:tw-justify-end tw-gap-y-[15px]"
        >
          <div
            id="vendor-question-create-bulk-action"
            @click="handleShowBulkAction"
          >
            <ButtonBulkActions
              :active="selectedQuestionsHeadings.length > 0"
              :selected-number="selectedQuestionsHeadings.length"
              :show-more-actions="false"
              :id-popover="'vendor-question-create-bulk-action-popover'"
              :show-acction-click="true"
            >
              <CustomDropDownItem
                :style="'normal'"
                :id-text="'app-component-assessments-question-bulk-action-item-add-1'"
                @click="() => {}"
              />
            </ButtonBulkActions>
          </div>
          <div class="tw-flex tw-gap-[15px]">
            <slot />
          </div>
        </div>
        <div
          id="popover-vendor-question-target-1"
          class="toggle-switch-view tw-relative"
          :class="isCheckToggleOptionSetting ? 'setting-option-selected' : ''"
          @click="openDisplayOption"
          @mouseover="isCogHover = true"
          @mouseout="isCogHover = false"
        >
          <label class="tw-cursor-pointer">
            <span class="tw-p-[14px]">
              <img
                v-show="isCheckToggleOptionSetting"
                src="@/assets/img/setting_option_selected.svg"
                alt=""
              />
              <img
                v-show="
                  !isCheckToggleOptionSetting && !isShowToolTip && !isCogHover
                "
                src="@/assets/img/setting_option.svg"
                alt=""
              />
              <img
                v-show="
                  !isCheckToggleOptionSetting && (isShowToolTip || isCogHover)
                "
                src="@/assets/img/setting_option_active.svg"
                alt=""
              />
            </span>
          </label>
        </div>
        <b-popover
          ref="popover_option"
          target="popover-vendor-question-target-1"
          placement="bottom-end"
          click="true"
          :offset="15"
          :custom-class="`custom-actions-popover assessment-display-options`"
          class="tw-absolute"
          @show="isShowToolTip = true"
          @hidden="isShowToolTip = false"
        >
          <AssessmentDisplayOptions :list-option="listOption" />
        </b-popover>
      </div>
    </div>

    <div
      :class="`${!questionList.length ? 'tw-mt-[20px]' : ''}`"
      data-cy="questions-section"
    >
      <draggable
        v-if="!checklistRequestedTemplateDetailLoading"
        :list="questionList"
        item-key="id"
        handle=".drag-handle"
        @change="changeItem"
      >
        <template #item="{ element, index }">
          <div
            v-if="element.type === VENDOR_QUESTION_RENDER_TYPE.question"
            :class="`${
              questionList[index - 1]?.type ===
              VENDOR_QUESTION_RENDER_TYPE.question
                ? 'tw-mt-[15px]'
                : ''
            }  `"
          >
            <VendorAssessmentQuestion
              :ref="(el) => setRef(el, index)"
              :item="element"
              :index="index"
              :level="element.level"
              :template-id="templateId"
              :is-selected="
                selectedQuestionsHeadings.filter(
                  (item) =>
                    (item.itemMasterId &&
                      item.itemMasterId === element.itemMasterId) ||
                    item.id === element.id,
                ).length > 0
              "
              @handle-update-data="updateQuestion"
              @handle-select-item="onQuestionSelect"
              @remove-step="
                (index: number) => onRemoveItem(index, element.type)
              "
            />
          </div>
          <div v-else class="tw-ml-[-15px] tw-mt-[32.5px] tw-mb-[12.5px]">
            <VendorAssessmentQuestionHeading
              :ref="(el) => setRef(el, index)"
              :item="element"
              :index="index"
              :level="element.level"
              :template-id="templateId"
              :is-selected="
                selectedQuestionsHeadings.filter(
                  (item) =>
                    (item.itemMasterId &&
                      item.itemMasterId === element.itemMasterId) ||
                    item.id === element.id,
                ).length > 0
              "
              @handle-update-data="updateHeading"
              @handle-select-item="onHeadingSelect"
              @remove-step="
                (index: number) => onRemoveItem(index, element.type)
              "
            />
          </div>
        </template>
      </draggable>

      <div v-else class="tw-mt-[32.5px] tw-w-full">
        <div
          v-for="item in [1, 2, 3]"
          :key="item"
          class="custom-global-skeleton tw-flex tw-flex-col tw-relative assessmentQuestion question"
        >
          <div
            class="custom-global-skeleton tw-flex tw-flex-col tw-relative assessmentQuestion question"
          >
            <div
              class="custom-global-skeleton tw-flex tw-flex-row tw-justify-start"
            >
              <div class="tw-py-[20px]">
                <CustomCheckBox
                  :v-model:is-checked="false"
                  class="tw-h-[20px] tw-ml-[25px] !tw-mb-0"
                  size="20px"
                />
              </div>
              <div
                class="tw-leading-[100%] tw-py-[20px] tw-pr-[25px] tw- w-font-Poppins tw-text-[18px] tw-font-[600] tw-text-[#211F58]"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="`tw-flex tw-gap-[40px] tw-flex-col ${
        questionList[questionList.length - 1]?.type ===
        VENDOR_QUESTION_RENDER_TYPE.question
          ? 'tw-mt-[20px]'
          : ''
      } tw-mb-[40px] ${questionList.length ? '' : 'tw-mt-[20px]'}`"
    >
      <button
        id="vendor-assess-template-btn-add-new-question"
        data-cy="vendor-assess-template-add-new-question-btn"
        class="no-focus-out tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-flex tw-items-center tw-justify-between tw-w-full tw-leading-[130%] tw-bg-white tw-text-[#387DFF] tw-rounded-md tw-px-[25px] tw-py-[15px] tw-h-[58px]"
        @click="onAddNewQuestion"
      >
        <span class="tw-text-[14px] tw-font-semibold tw-leading-[130%]">{{
          getComponentUiText(
            "app-component-assessments-vendor-create-question-button-title-1",
          )
        }}</span>

        <div
          class="tw-flex tw-items-center tw-justify-center tw-w-[26px] tw-h-[26px] tw-min-w-[26px] tw-min-h-[26px] tw-bg-[#387DFF] tw-rounded-[50%]"
        >
          <span class="tw-text-white tw-text-base tw-font-medium tw-mt-[2px]"
            >+</span
          >
        </div>
      </button>
      <div class="tw-w-full tw-flex tw-items-center tw-justify-center">
        <button
          id="vender-create-section-btn"
          data-cy="vender-assess-template-add-section-header-btn"
          class="no-focus-out tw-border-[1px] tw-flex tw-items-center tw-justify-center tw-leading-[130%] tw-text-[#B7B7B7] tw-rounded-md tw-h-fit tw-gap-3"
          @click="onAddNewSection"
        >
          <span
            class="tw-text-[10px] tw-font-semibold tw-leading-[100%] tw-uppercase"
          >
            {{
              getComponentUiText(
                "app-component-assessments-vendor-create-section-button-insert-section-header-1",
              )
            }}
          </span>

          <div
            class="tw-flex tw-items-center tw-justify-center tw-w-[16px] tw-h-[16px] tw-min-w-[16px] tw-min-h-[16px] tw-bg-[#878787] tw-rounded-[50%]"
          >
            <span class="tw-text-white tw-text-base tw-font-medium tw-mt-[2px]"
              >+</span
            >
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import { Ref, computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import AssessmentCategoryHeader from "../assessment/assessmentCategoryHeader.vue";
import ButtonBulkActions from "../common/setting/buttonBulkActions.vue";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import AssessmentDisplayOptions from "../assessment/assessmentDisplayOptions.vue";
import BaseSearchbox from "../common/form/baseSearchbox.vue";
import CustomCheckBox from "@/components/common/customCheckBox.vue";
import draggable from "vuedraggable";
import VendorAssessmentQuestion from "./vendorAssessmentQuestion.vue";
import {
  successStatusCodes,
  VENDOR_QUESTION_RENDER_TYPE,
  VENDOR_TEMPLATE_API_STATUS,
} from "@/utils/constants";
import VendorAssessmentQuestionHeading from "./vendorAssessmentQuestionHeading.vue";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import store from "@/store";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Vendor } from "@/services/apiRoutes/routes";
import {
  createRequestTemplateItem,
  updateChecklistRequestedTemplateItem,
  putRequestTemplateItem,
} from "@/services/vendor";
import cloneDeep from "lodash/cloneDeep";
import router from "@/router";

const valueSearch = ref("");
const isShowToolTip: Ref<boolean> = ref(false);
const isCogHover: Ref<boolean> = ref(false);
const popover_option: any = ref(null);
const isCheckToggleOptionSetting: Ref<boolean> = ref(false);
const checklistRequestedTemplateDetailLoading = computed(
  () => store.state.Vendor.checklistRequestedTemplateDetailLoading,
);

const emits = defineEmits(["isCallUpdate"]);

const listOption = computed(() => []);
const selectedQuestionsHeadings: any = ref([]);
const formatHierarchy = (items) => {
  if (!items) return [];
  // Format items with level and type
  const formattedItems = items.map((item) => {
    let level = 0;
    if (
      !item.itemMasterIsHeading &&
      !item.itemMasterParentGroupingId1 &&
      !item.itemMasterParentGroupingId2 &&
      !item.itemMasterParentGroupingId3 &&
      !item.itemMasterParentGroupingId4
    ) {
      return {
        ...item,
        level: 1,
        itemMasterParentGroupingId1: -1,
        id: item.itemMasterId,
        type: VENDOR_QUESTION_RENDER_TYPE.question,
        questionName: item.itemMasterHeadingLabel || item.itemMasterName,
        importanceId: item.itemMasterImportanceId,
        responseType: item.itemMasterComplianceTypeId,
        description: item.itemMasterDescription,
      };
    }
    if (!item.itemMasterParentGroupingId1) level = 0;
    else if (!item.itemMasterParentGroupingId2) level = 1;
    else if (!item.itemMasterParentGroupingId3) level = 2;
    else if (!item.itemMasterParentGroupingId4) level = 3;
    else level = 4;
    return {
      ...item,
      level,
      id: item.itemMasterId,
      type: item.itemMasterIsHeading
        ? VENDOR_QUESTION_RENDER_TYPE.heading
        : VENDOR_QUESTION_RENDER_TYPE.question,
      questionName: item.itemMasterHeadingLabel || item.itemMasterName,
      importanceId: item.itemMasterImportanceId,
      responseType: item.itemMasterComplianceTypeId,
      description: item.itemMasterDescription,
    };
  });
  // if itemMasterParentGroupingId1 exist but not include in formattedItems, it is level 0 and update itemMasterParentGroupingId1
  const otherItems = formattedItems.filter(
    (item) =>
      item.level !== 0 &&
      !formattedItems.filter(
        (item2) => item2.itemMasterId === item.itemMasterParentGroupingId1,
      ).length,
  );

  const existItems = formattedItems.filter(
    (item) => !otherItems.find((i) => i.itemMasterId === item.itemMasterId),
  );

  const otherItemsFormarted = findRoot(otherItems, formattedItems);
  const level0 = formattedItems
    .concat(otherItemsFormarted)
    .filter((item) => item.level === 0)
    .sort((a, b) => a.itemMasterOrder - b.itemMasterOrder);
  if (otherItems.length > 0) {
    level0.push({
      type: VENDOR_QUESTION_RENDER_TYPE.heading,
      itemMasterHeadingLabel: getComponentUiText(
        "app-component-assessments-input-question-other-1",
      ),
      itemMasterId: -1,
      id: -1,
      level: 0,
    });
  }

  const itemsBeforeTraverse = existItems.concat(otherItemsFormarted);
  const resultAterTraverse = traverseLevel(level0, itemsBeforeTraverse, 1);
  const exeptionItems = formattedItems
    .filter(
      (item) =>
        !resultAterTraverse.find((i) => i.itemMasterId === item.itemMasterId),
    )
    .map((item) => {
      return {
        ...item,
        level: 1,
        itemMasterParentGroupingId1: -1,
      };
    })
    .sort((a, b) => a.itemMasterOrder - b.itemMasterOrder);
  let result;
  if (exeptionItems.length > 0) {
    if (resultAterTraverse.length > 0) {
      // exist other heading
      if (
        resultAterTraverse[resultAterTraverse.length - 1]
          .itemMasterParentGroupingId1 === -1
      ) {
        result = resultAterTraverse.concat(exeptionItems);
      } else {
        resultAterTraverse.push({
          type: VENDOR_QUESTION_RENDER_TYPE.heading,
          itemMasterHeadingLabel: getComponentUiText(
            "app-component-assessments-input-question-other-1",
          ),
          itemMasterId: -1,
          id: -1,
          level: 0,
        });
        result = resultAterTraverse.concat(exeptionItems);
      }
    }
  } else {
    result = resultAterTraverse;
  }
  // remove heading other if it is last item
  if (
    result.length > 0 &&
    result[result.length - 1].itemMasterId === -1 &&
    result[result.length - 1].level === 0
  ) {
    result.pop();
  }
  return result;
};

const findRoot = (remainItems, items) => {
  const updatedItems = remainItems.map((item) => {
    return {
      ...item,
      level: item.level - 1,
      itemMasterParentGroupingId1: item.itemMasterParentGroupingId2,
      itemMasterParentGroupingId2: item.itemMasterParentGroupingId3,
      itemMasterParentGroupingId3: item.itemMasterParentGroupingId4,
      itemMasterParentGroupingId4: null,
    };
  });
  const level0: any = [],
    remainLevel: any = [];
  updatedItems.forEach((item) =>
    item.level === 0 ? level0.push(item) : remainLevel.push(item),
  );
  // find itemMasterParentGroupingId1
  const remainLevelSort: any = [];
  remainLevel.forEach((item) => {
    if (
      items.find((i) => i.itemMasterId === item.itemMasterParentGroupingId1)
    ) {
      remainLevelSort.push(item);
      return;
    }

    if (
      items.find((i) => i.itemMasterId === item.itemMasterParentGroupingId2)
    ) {
      item.level = item.level - 1;
      item.itemMasterParentGroupingId1 = item.itemMasterParentGroupingId2;
      item.itemMasterParentGroupingId2 = item.itemMasterParentGroupingId3;
      item.itemMasterParentGroupingId3 = item.itemMasterParentGroupingId4;
      item.itemMasterParentGroupingId4 = null;
      remainLevelSort.push(item);
      return;
    }

    if (
      items.find((i) => i.itemMasterId === item.itemMasterParentGroupingId3)
    ) {
      item.level = item.level - 1;
      item.itemMasterParentGroupingId1 = item.itemMasterParentGroupingId3;
      item.itemMasterParentGroupingId2 = item.itemMasterParentGroupingId4;
      item.itemMasterParentGroupingId3 = null;
      item.itemMasterParentGroupingId4 = null;
      remainLevelSort.push(item);
      return;
    }

    if (
      items.find((i) => i.itemMasterId === item.itemMasterParentGroupingId4)
    ) {
      item.level = item.level - 1;
      item.itemMasterParentGroupingId1 = item.itemMasterParentGroupingId4;
      item.itemMasterParentGroupingId2 = null;
      item.itemMasterParentGroupingId3 = null;
      item.itemMasterParentGroupingId4 = null;
      remainLevelSort.push(item);
      return;
    }
    remainLevelSort.push({
      ...item,
      level: 0,
      itemMasterParentGroupingId1: null,
      itemMasterParentGroupingId2: null,
      itemMasterParentGroupingId3: null,
      itemMasterParentGroupingId4: null,
    });
  });
  const result = remainLevelSort.concat(level0);
  // add level 0 to other heading
  return result
    .map((item) => {
      if (item.level === 0) {
        item.level = 1;
        item.itemMasterParentGroupingId1 = -1;
      } else {
        const Parent = items.find(
          (i) => i.itemMasterId === item.itemMasterParentGroupingId1,
        );
        item.level = Parent.level + 1;
        for (let i = 1; i < Parent.level + 1; i++) {
          item[`itemMasterParentGroupingId${i}`] =
            Parent[`itemMasterParentGroupingId${i}`];
        }
        item[`itemMasterParentGroupingId${Parent.level + 1}`] =
          Parent.itemMasterId;
      }
      return item;
    })
    .flat();
};

const traverseLevel = (result, items, level) => {
  if (level === 5) return result;
  const finalResult = cloneDeep(result);
  result.forEach((item) => {
    if (item.level === level - 1) {
      const children = items
        .filter(
          (child) =>
            child[`itemMasterParentGroupingId${level}`] === item.itemMasterId &&
            child.level === level,
        )
        .sort((a, b) => a.itemMasterOrder - b.itemMasterOrder);
      const idx = finalResult.findIndex(
        (i) => i.itemMasterId === item.itemMasterId,
      );
      finalResult.splice(idx + 1, 0, ...children);
    }
  });
  return traverseLevel(finalResult, items, level + 1);
};

onBeforeUnmount(() => {
  if (isRemoveItem.value) {
    store.dispatch("Vendor/fetchRequestedTemplateDetail", {
      templateId: templateId.value,
    });
  }
});
const isRemoveItem = ref(false);

onMounted(() => {
  try {
    store.dispatch("Assessment/fetchImportanceAssessment");
    store.dispatch("Assessment/fetchAssessmentQuestionTypes", "clr");
  } catch (error) {
    console.log("error", error);
  }
  questionList.value = cloneDeep(checklistRequestedTemplateDetail.value);
});

const checklistRequestedTemplateDetail: any = computed(() => {
  const details = store.state.Vendor.checklistRequestedTemplateDetail[0];
  return formatHierarchy(
    details?.items?.filter((item) => !item.itemMasterIsArchived),
  );
});

const questionList: any = ref([]);
const pendingQuestionList: any = ref([]);
const pendingQuestionOrderList: any = ref([]);
const templateId = computed(() => store.state.Vendor?.templateEditId);
const itemRef: any = ref([]);

const setRef = (el: any, index: number) => {
  if (el) {
    itemRef.value[index] = el;
  }
};

watch(
  () => checklistRequestedTemplateDetail.value,
  (value) => {
    const items = store.state.Vendor.checklistRequestedTemplateDetail[0].items;
    if (items) {
      const formatHierarchyArray = formatHierarchy(
        items.filter((item) => !item.itemMasterIsArchived),
      );
      questionList.value = cloneDeep(formatHierarchyArray).concat(
        pendingQuestionList.value.sort((a, b) => a.order - b.order),
      );
      pendingQuestionList.value = [];
    }
  },
);
const isSubmit = computed(() => store.state.Vendor.isShowButton);

const onRemoveItem = async (index: number, type) => {
  try {
    if (questionList.value[index].itemMasterId) {
      await updateChecklistRequestedTemplateItem({
        templateId: templateId.value,
        params: {
          itemMasterId: questionList.value[index].itemMasterId,
          isArchived: true,
        },
      });
      showSuccessToast(
        getComponentUiText(
          type === VENDOR_QUESTION_RENDER_TYPE.heading
            ? "app-assessment-vendor-delete-heading-success-1"
            : "app-assessment-vendor-delete-question-success-1",
        ),
      );
      isRemoveItem.value = true;
    }
    if (type === VENDOR_QUESTION_RENDER_TYPE.heading) {
      const nextHeadingIndex = questionList.value.findIndex(
        (item: any, i: number) =>
          i > index && item.type === VENDOR_QUESTION_RENDER_TYPE.heading,
      );
      const children =
        nextHeadingIndex !== -1
          ? questionList.value.slice(index + 1, nextHeadingIndex)
          : questionList.value.slice(index + 1);
      const childrenPromise = children
        .filter((item) => item.itemMasterId)
        .map((item: any) =>
          updateChecklistRequestedTemplateItem({
            templateId: templateId.value,
            params: {
              itemMasterId: item.itemMasterId,
              parentGroupingId1: null,
            },
          }),
        );
      await Promise.all(childrenPromise);
      questionList.value.splice(index, children.length + 1);
      if (!children.length) return;
      const otherHeadingIndex = questionList.value.findIndex(
        (item: any) =>
          item.itemMasterId === -1 &&
          item.type === VENDOR_QUESTION_RENDER_TYPE.heading &&
          item.itemMasterHeadingLabel ===
            getComponentUiText(
              "app-component-assessments-input-question-other-1",
            ),
      );
      if (otherHeadingIndex === -1) {
        questionList.value.push({
          type: VENDOR_QUESTION_RENDER_TYPE.heading,
          itemMasterHeadingLabel: getComponentUiText(
            "app-component-assessments-input-question-other-1",
          ),
          id: -1,
          level: 0,
          itemMasterId: -1,
        });
        questionList.value = [
          ...questionList.value,
          ...children.map((item) => {
            return {
              ...item,
              parentGroupingId1: null,
            };
          }),
        ];
      } else {
        questionList.value = [
          ...questionList.value.slice(0, otherHeadingIndex + 1),
          ...children.map((item) => {
            return {
              ...item,
              parentGroupingId1: null,
            };
          }),
          ...questionList.value.slice(otherHeadingIndex + 1),
        ];
      }
    } else {
      questionList.value.splice(index, 1);
      const itemBefore = questionList.value[index - 1];
      const itemAfter = questionList.value[index];
      if (
        itemBefore?.type === VENDOR_QUESTION_RENDER_TYPE.heading &&
        itemBefore?.itemMasterId === -1 &&
        itemBefore?.itemMasterHeadingLabel ===
          getComponentUiText(
            "app-component-assessments-input-question-other-1",
          ) &&
        (itemAfter?.type === VENDOR_QUESTION_RENDER_TYPE.heading || !itemAfter)
      ) {
        questionList.value.splice(index - 1, 1);
      }
    }
    itemRef.value.splice(index, 1);
  } catch (error) {
    showErrorAPI(error, Vendor.putChecklistRequestedTemplateItem);
  }
};

const onAddNewSection = () => {
  store.commit("Vendor/SET_IS_UPDATE_QUESTION_ITEM", true);
  questionList.value.push({
    type: VENDOR_QUESTION_RENDER_TYPE.heading,
    id: Math.random(),
    level: 0,
  });
  if (!isSubmit.value) {
    eventEmitter.emit(EmitterEvents.CREATE_VENDOR_TEMPLATE);
  }
};

const onAddNewQuestion = () => {
  store.commit("Vendor/SET_IS_UPDATE_QUESTION_ITEM", true);
  questionList.value.push({
    type: VENDOR_QUESTION_RENDER_TYPE.question,
    id: Math.random(),
    level: questionList.value[questionList.value.length - 1]?.level,
  });
  if (!isSubmit.value) {
    eventEmitter.emit(EmitterEvents.CREATE_VENDOR_TEMPLATE);
  }
};

const onChangeValueSearch = (value: string) => {
  valueSearch.value = value;
};

const openDisplayOption = () => {
  setTimeout(() => {
    popover_option?.value?.$emit("show");
  }, 500);
};

const handleShowBulkAction = () => {
  //   isShowMoreActions.value = !isShowMoreActions.value;
};

const updateHeading = (text: string, index: number) => {
  if (!questionList.value[index]?.itemMasterId) {
    store.commit("Vendor/SET_IS_UPDATE_QUESTION_ITEM", true);
  }
  questionList.value[index].headingLabel = text;
};

const updateQuestion = (item: any, index: number) => {
  if (!questionList.value[index]?.itemMasterId) {
    store.commit("Vendor/SET_IS_UPDATE_QUESTION_ITEM", true);
  }
  questionList.value[index] = { ...questionList.value[index], ...item };
};

const onQuestionSelect = (value: boolean, index: number) => {
  const item = questionList.value[index];
  if (value) {
    selectedQuestionsHeadings.value.push({ ...item, index });
    const childrens = questionList.value.filter(
      (i) =>
        i.itemMasterParentGroupingId1 === item.itemMasterParentGroupingId1 &&
        i.itemMasterParentGroupingId1,
    );
    const childSelected = selectedQuestionsHeadings.value.filter(
      (i) =>
        i.itemMasterParentGroupingId1 === item.itemMasterParentGroupingId1 &&
        i.itemMasterParentGroupingId1,
    );
    if (childrens.length === childSelected.length && childrens.length > 0) {
      const parent = questionList.value.findIndex(
        (i) => i.itemMasterId === item.itemMasterParentGroupingId1,
      );
      if (parent !== -1) {
        selectedQuestionsHeadings.value.push({
          index: parent,
          ...questionList.value[parent],
        });
      }
    }
  } else {
    const index = selectedQuestionsHeadings.value.findIndex(
      (i) => i.id === item.id,
    );
    selectedQuestionsHeadings.value.splice(index, 1);
    const parentIndex = selectedQuestionsHeadings.value.findIndex(
      (i) =>
        i.itemMasterId && i.itemMasterId === item.itemMasterParentGroupingId1,
    );
    if (parentIndex !== -1) {
      selectedQuestionsHeadings.value.splice(parentIndex, 1);
    }
  }
};

const onHeadingSelect = (value: boolean, index: number) => {
  const item = questionList.value[index];
  if (value) {
    selectedQuestionsHeadings.value.push({ ...item, index });
    questionList.value.forEach((i, idx) => {
      if (
        item.itemMasterId &&
        (i.itemMasterParentGroupingId1 === item.itemMasterId ||
          i.itemMasterParentGroupingId2 === item.itemMasterId)
      ) {
        selectedQuestionsHeadings.value.push({ ...i, index: idx });
      }
    });
    // deduplicate by itemMasterId
    if (item.itemMasterId) {
      selectedQuestionsHeadings.value = selectedQuestionsHeadings.value.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.itemMasterId === item.itemMasterId),
      );
    }
  } else {
    const index = selectedQuestionsHeadings.value.findIndex(
      (i) => i.id === item.id,
    );
    selectedQuestionsHeadings.value.splice(index, 1);
    const childrens = selectedQuestionsHeadings.value.filter(
      (i) =>
        item.itemMasterId &&
        (i.itemMasterParentGroupingId1 === item.itemMasterId ||
          i.itemMasterParentGroupingId2 === item.itemMasterId),
    );
    childrens.forEach((child) => {
      const childIndex = selectedQuestionsHeadings.value.findIndex(
        (i) => i.id === child.id,
      );
      selectedQuestionsHeadings.value.splice(childIndex, 1);
    });
  }
};
const changeItem = async (event: any) => {
  try {
    if (
      event.moved.element.itemMasterId === -1 ||
      !event.moved.element.itemMasterId
    ) {
      return;
    }
    // remove other heading if exist in selectedQuestionsHeadings
    selectedQuestionsHeadings.value = selectedQuestionsHeadings.value.filter(
      (item) => item.itemMasterId !== -1,
    );
    let newIndex = event.moved.newIndex;
    const oldIndex = event.moved.oldIndex;
    let isSubmitQuestion = false;
    if (selectedQuestionsHeadings.value.find((i) => i.index === newIndex)) {
      questionList.value.splice(oldIndex, 0, event.moved.element);
      if (newIndex > oldIndex) {
        questionList.value.splice(newIndex + 1, 1);
      } else {
        questionList.value.splice(newIndex, 1);
      }
      return;
    }
    if (
      questionList.value[newIndex - 1] &&
      !questionList.value[newIndex - 1].itemMasterId
    ) {
      isSubmitQuestion = true;
    }
    let cloneQuestionList = cloneDeep(questionList.value);
    // remove selected Item
    cloneQuestionList = cloneQuestionList.filter(
      (item) =>
        selectedQuestionsHeadings.value.findIndex((i) => i.id === item.id) ===
        -1,
    );
    if (selectedQuestionsHeadings.value.length > 0) {
      // push selectedQuestionsHeadings to new index
      const cloneSelectedQuestionsHeadings =
        selectedQuestionsHeadings.value.sort(
          (a, b) => a.itemMasterOrder - b.itemMasterOrder,
        );
      let maxIndex;
      if (
        cloneSelectedQuestionsHeadings[0].itemMasterId ===
        event.moved.element.itemMasterId
      ) {
        maxIndex = oldIndex;
      } else {
        maxIndex = questionList.value.findIndex(
          (i) =>
            i.itemMasterId === cloneSelectedQuestionsHeadings[0].itemMasterId,
        );
      }
      if (maxIndex < newIndex) {
        const countIndexs = cloneSelectedQuestionsHeadings.filter(
          (i) => i.itemMasterOrder > event.moved.element.itemMasterOrder,
        ).length;
        newIndex = newIndex - countIndexs > 0 ? newIndex - countIndexs : 0;
      }
      selectedQuestionsHeadings.value
        .sort((a, b) => b.itemMasterOrder - a.itemMasterOrder)
        .forEach((item) => {
          cloneQuestionList.splice(newIndex, 0, item);
        });
    }
    const bodyPUTOrder: any = reCaculateOrderAndHeadings(cloneQuestionList);
    let dataUpdated;
    if (isSubmitQuestion) {
      dataUpdated = await submitQuestion(true, bodyPUTOrder);
    } else {
      processPUTDragDropItems(bodyPUTOrder, []);
    }
    selectedQuestionsHeadings.value = [];
  } catch (error) {
    showErrorAPI(error, Vendor.putChecklistRequestedTemplateItem);
  }
};

const processPUTDragDropItems = async (
  bodyPUTOrder,
  dataWithHeading,
  isSubmitQuestion = false,
) => {
  if (bodyPUTOrder.length) {
    const promises: any = [];
    pendingQuestionOrderList.value = [];
    const statuss: any = [];
    bodyPUTOrder.forEach((item) => {
      if (
        item.parentGroupingId1 === undefined &&
        dataWithHeading &&
        dataWithHeading.length
      ) {
        const itemUpdated = dataWithHeading.find(
          (i) => i.itemMasterId === item.itemMasterId,
        );
        item.parentGroupingId1 = itemUpdated?.parentGroupingId1;
        item.parentGroupingId1
          ? promises.push(putRequestTemplateItem(templateId.value, item))
          : pendingQuestionOrderList.value.push(item);
        if (item.parentGroupingId1) {
          statuss.push({
            id: item.itemMasterId,
            loading: VENDOR_TEMPLATE_API_STATUS.isloading,
          });
        }
      } else {
        if (item.parentGroupingId1 === -1) {
          item.parentGroupingId1 = null;
        }
        statuss.push({
          id: item.itemMasterId,
          loading: VENDOR_TEMPLATE_API_STATUS.isloading,
        });
        promises.push(putRequestTemplateItem(templateId.value, item));
      }
    });
    if (!promises.length) {
      return;
    }
    try {
      statuss.forEach((item) => {
        store.dispatch("Vendor/setAddTemplateItemStatus", item);
      });
      const res = await Promise.all(promises);
      res.forEach((item, idx) => {
        const data = item.data?.data?.templates;
        store.dispatch("Vendor/setAddTemplateItemStatus", {
          id: statuss[idx].id,
          loading: data
            ? VENDOR_TEMPLATE_API_STATUS.suceess
            : VENDOR_TEMPLATE_API_STATUS.error,
        });
      });
      const template = res[promises.length - 1]?.data?.data?.templates;
      if (!isSubmitQuestion) {
        pendingQuestionList.value = questionList.value.filter(
          (item) => !item.itemMasterId,
        );
      }

      if (dataWithHeading.length === 0) {
        store.commit(
          "Vendor/SET_CHECKLIST_REQUESTED_TEMPLATE_DETAIL_BY_ID",
          template,
        );
      }
    } catch (error) {
      showErrorAPI(error, Vendor.putChecklistRequestedTemplateItem);
    }
  }
};

const reCaculateOrderAndHeadings = (questions) => {
  const bodys: any = [];
  let order = questions[0].itemMasterOrder - 1;
  questions.forEach((item, index) => {
    const putBody = {};
    if (item.id === -1) return;
    if (item.itemMasterOrder <= order || item.itemMasterOrder === undefined) {
      item.itemMasterOrder = order + 1;
      if (!item.itemMasterId) {
        item.order = order + 1;
      } else {
        putBody["order"] = item.itemMasterOrder;
      }
    }
    order = item.itemMasterOrder;
    if (item.type === VENDOR_QUESTION_RENDER_TYPE.question) {
      let itemMasterParentGroupingId1;
      if (index === 0) {
        itemMasterParentGroupingId1 = -1;
      } else {
        const itemBefore = questions[index - 1];
        if (itemBefore.type === VENDOR_QUESTION_RENDER_TYPE.heading) {
          itemMasterParentGroupingId1 = itemBefore.itemMasterId;
        } else {
          itemMasterParentGroupingId1 = itemBefore.itemMasterParentGroupingId1;
        }
      }
      if (itemMasterParentGroupingId1 !== item.itemMasterParentGroupingId1) {
        item.itemMasterParentGroupingId1 = itemMasterParentGroupingId1;
        putBody["parentGroupingId1"] = itemMasterParentGroupingId1;
      }
    }
    if (Object.keys(putBody).length && item.itemMasterId) {
      bodys.push({
        itemMasterId: item.itemMasterId,
        ...putBody,
      });
    }
  });
  questionList.value = questions;
  return bodys;
};

const submitQuestion = async (isOrder = false, bodyPUTOrder = []) => {
  const validListPromiss = itemRef.value.map((item) => item?.saveChanges());
  const resValid = await Promise.all(validListPromiss);
  const isValid = resValid.every((item: any) => item);
  if (!templateId.value) {
    store.commit("Vendor/SET_IS_UPDATE_QUESTION_ITEM", false);
    return;
  }
  if (!isOrder) {
    const bodysOrder = calculateOrder(questionList.value);
    if (bodysOrder.length) {
      await Promise.all(bodysOrder);
    }
  }
  if (!isValid) {
    emits("isCallUpdate", false);
    return;
  }

  const dataUpdated = await createHeading(isOrder, bodyPUTOrder);
  store.commit("Vendor/SET_IS_UPDATE_QUESTION_ITEM", false);
  return dataUpdated;
};

const createHeading = async (isOrder, bodyPUTOrder) => {
  pendingQuestionList.value = [];
  try {
    const listHeadingCreate = questionList.value
      .map((item: any, index: number) => {
        return { ...item, index };
      })
      .filter(
        (item) =>
          !item?.itemMasterId &&
          item.type === VENDOR_QUESTION_RENDER_TYPE.heading,
      );
    const listHeadingCreateParams = listHeadingCreate.map((item) => {
      return {
        name: item.headingLabel,
        isHeading: true,
        order: item.itemMasterOrder,
        importanceId: "na",
        complianceTypeId: "na",
        description: null,
        notes: null,
        guidance: null,
        headingLabel: item.headingLabel,
        parentGroupingId1: null,
        parentGroupingId2: null,
        parentGroupingId3: null,
        parentGroupingId4: null,
        id: item.id,
      };
    });
    let isError = false,
      dataRes,
      statusAPIs: any = [];
    for (let i = 0; i < listHeadingCreateParams.length; i++) {
      const id = listHeadingCreate[i].id;
      try {
        store.dispatch("Vendor/setAddTemplateItemStatus", {
          id: id,
          loading: VENDOR_TEMPLATE_API_STATUS.isloading,
        });
        // delete id from params
        delete listHeadingCreateParams[i].id;
        const res = await createRequestTemplateItem(
          templateId.value,
          listHeadingCreateParams[i],
        );

        if (res?.status === successStatusCodes.OK) {
          showSuccessToast(
            getComponentUiText(
              "app-assessment-vendor-heading-added-successfully-1",
            ),
          );
        }
        dataRes = res;
        const dataItems = res?.data.data.templates[0].items;
        const params = listHeadingCreateParams[i];
        const itemData = dataItems
          .filter((item) => !item.itemMasterIsArchived)
          .find((dataItem: any) => {
            return (
              params.name === dataItem.itemMasterName &&
              params.isHeading === dataItem.itemMasterIsHeading &&
              params.order === dataItem.itemMasterOrder &&
              params.parentGroupingId1 ===
                dataItem.itemMasterParentGroupingId1 &&
              params.parentGroupingId2 ===
                dataItem.itemMasterParentGroupingId2 &&
              params.parentGroupingId3 ===
                dataItem.itemMasterParentGroupingId3 &&
              params.parentGroupingId4 === dataItem.itemMasterParentGroupingId4
            );
          });
        statusAPIs.push({
          id: id,
          newId: itemData.itemMasterId,
          loading: VENDOR_TEMPLATE_API_STATUS.suceess,
        });
        questionList.value[listHeadingCreate[i].index].itemMasterId =
          itemData.itemMasterId;

        emits("isCallUpdate", true);
      } catch (error) {
        emits("isCallUpdate", false);
        pendingQuestionList.value.push(listHeadingCreate[i]);
        statusAPIs.push({
          id,
          loading: VENDOR_TEMPLATE_API_STATUS.error,
        });
        isError = true;
        showErrorAPI(error, Vendor.postRequestTemplateItem);
      }
    }

    if (!isError && !isOrder) {
      setTimeout(() => {
        router.push({ path: "/assess/vendor/manage" });
      }, 1000);
    }
    const listQuestionCreate = questionList.value
      .map((item: any, index: number) => {
        return { ...item, index };
      })
      .filter(
        (item: any) =>
          (!item?.itemMasterId || !item.itemMasterParentGroupingId1) &&
          item.type === VENDOR_QUESTION_RENDER_TYPE.question,
      );
    if (listQuestionCreate.length === 0) {
      statusAPIs.forEach((status) => {
        store.dispatch("Vendor/setAddTemplateItemStatus", status);
      });
      if (dataRes?.data.data.templates) {
        store.commit(
          "Vendor/SET_CHECKLIST_REQUESTED_TEMPLATE_DETAIL_BY_ID",
          dataRes?.data.data.templates,
        );
      }
      if (!isError) {
        if (!isOrder) {
          setTimeout(() => {
            router.push({ path: "/assess/vendor/manage" });
          }, 1000);
        }
      }
      return;
    }
    return await createQuestion(
      listQuestionCreate,
      dataRes,
      statusAPIs,
      isOrder,
      bodyPUTOrder,
    );
  } catch (error) {
    showErrorAPI(error, Vendor.postRequestTemplateItem);
    return {};
  }
};

const createQuestion = async (
  listQuestionCreate,
  resPostHeading,
  statusAPIs,
  isOrder,
  bodyPUTOrder,
) => {
  try {
    let listQuestionCreateParams = listQuestionCreate.map((item: any) => {
      const parent1 = questionList.value
        .slice(0, item.index)
        .reverse()
        .find((item) => item.type === VENDOR_QUESTION_RENDER_TYPE.heading);

      const parentId1 = parent1
        ? parent1.itemMasterId
          ? parent1.itemMasterId !== -1
            ? parent1.itemMasterId
            : null
          : undefined
        : null;

      return item.itemMasterId
        ? {
            parentGroupingId1: parentId1,
            itemMasterId: item.itemMasterId,
          }
        : {
            name: item.itemMasterName,
            isHeading: false,
            order: item.itemMasterOrder,
            importanceId: item.importanceId,
            complianceTypeId: item.responseType,
            description: item.description ?? null,
            notes: null,
            guidance: null,
            headingLabel: item.questionName,
            parentGroupingId1: parentId1,
            parentGroupingId2: null,
            parentGroupingId3: null,
            parentGroupingId4: null,
            id: item.id,
          };
    });
    // process drag & drop items if exist
    const orderItems = listQuestionCreateParams.filter(
      (item) => item.itemMasterId,
    );
    let bodyPUTOrders = pendingQuestionOrderList.value;
    bodyPUTOrder.forEach((item) => {
      const index = bodyPUTOrders.findIndex(
        (i) => i.itemMasterId === item.itemMasterId,
      );
      if (index !== -1) {
        bodyPUTOrders[index] = { ...bodyPUTOrders[index], ...item };
      } else {
        bodyPUTOrders.push(item);
      }
    });
    processPUTDragDropItems(bodyPUTOrders, orderItems, true);
    // remove item has itemMasterId
    listQuestionCreateParams = listQuestionCreateParams.filter(
      (item) => !item.itemMasterId,
    );
    let dataRes: any = resPostHeading,
      isError = false;

    for (let i = 0; i < listQuestionCreateParams.length; i++) {
      const id = listQuestionCreateParams[i].id;
      try {
        if (listQuestionCreateParams[i].parentGroupingId1 === undefined)
          throw new Error();
        store.dispatch("Vendor/setAddTemplateItemStatus", {
          id,
          loading: VENDOR_TEMPLATE_API_STATUS.isloading,
        });
        delete listQuestionCreateParams[i].id;
        const res = await createRequestTemplateItem(
          templateId.value,
          listQuestionCreateParams[i],
        );
        dataRes = res;
        const dataItems = res?.data.data.templates[0].items;
        const params = listQuestionCreateParams[i];
        const itemData = dataItems
          .filter((item) => !item.itemMasterIsArchived)
          .find((dataItem: any) => {
            return (
              params.name === dataItem.itemMasterName &&
              params.isHeading === dataItem.itemMasterIsHeading &&
              params.order === dataItem.itemMasterOrder &&
              params.parentGroupingId1 ===
                dataItem.itemMasterParentGroupingId1 &&
              params.parentGroupingId2 ===
                dataItem.itemMasterParentGroupingId2 &&
              params.parentGroupingId3 ===
                dataItem.itemMasterParentGroupingId3 &&
              params.parentGroupingId4 ===
                dataItem.itemMasterParentGroupingId4 &&
              params.importanceId === dataItem.itemMasterImportanceId &&
              params.complianceTypeId === dataItem.itemMasterComplianceTypeId &&
              params.description === dataItem.itemMasterDescription
            );
          });
        statusAPIs.push({
          id,
          newId: itemData.itemMasterId,
          loading: VENDOR_TEMPLATE_API_STATUS.suceess,
        });
        questionList.value[listQuestionCreate[i].index] = {
          ...questionList.value[listQuestionCreate[i].index],
          ...itemData,
        };
        emits("isCallUpdate", true);
      } catch (error: any) {
        emits("isCallUpdate", false);
        isError = true;
        pendingQuestionList.value.push(listQuestionCreate[i]);
        if (error?.data) {
          statusAPIs.push({
            id,
            loading: VENDOR_TEMPLATE_API_STATUS.error,
          });
        }
        showErrorAPI(error, Vendor.postRequestTemplateItem);
      }
    }
    statusAPIs.forEach((status) => {
      store.dispatch("Vendor/setAddTemplateItemStatus", status);
    });
    if (dataRes?.data.data.templates) {
      store.commit(
        "Vendor/SET_CHECKLIST_REQUESTED_TEMPLATE_DETAIL_BY_ID",
        dataRes?.data.data.templates,
      );
    }
    if (!isError) {
      showSuccessToast(
        getComponentUiText(
          "app-assessment-vendor-heading-added-successfully-1",
        ),
      );
    }
  } catch (error) {
    showErrorAPI(error, Vendor.postRequestTemplateItem);
  }
};

const calculateOrder = (items) => {
  let order = 0,
    reset = false,
    bodysOrder: any = [];
  items.forEach((item, index) => {
    if (item.id === -1) return;
    if (!reset) {
      if (item?.itemMasterId) {
        order = item.itemMasterOrder;
      } else {
        if (
          items[index - 1] &&
          items[index - 1].itemMasterParentGroupingId1 === -1
        ) {
          // find max order of items
          const maxOrder = items.reduce(
            (max, item) =>
              item.itemMasterOrder > max ? item.itemMasterOrder : max,
            0,
          );
          item.itemMasterOrder = maxOrder + 1;
          order = maxOrder + 1;
        } else {
          item.itemMasterOrder = order + 1;
          order = order + 1;
        }
        reset = true;
      }
    } else {
      if (item?.itemMasterId) {
        bodysOrder.push(
          putRequestTemplateItem(templateId.value, {
            order: order + 1,
            itemMasterId: item.itemMasterId,
          }),
        );
      } else {
        if (items[index - 1].itemMasterParentGroupingId1 === -1) {
          // find max order of items
          const maxOrder = items.reduce(
            (max, item) =>
              item.itemMasterOrder > max ? item.itemMasterOrder : max,
            0,
          );
          item.itemMasterOrder = maxOrder + 1;
          order = maxOrder;
        } else {
          item.itemMasterOrder = order + 1;
        }
      }
      order = order + 1;
    }
  });
  return bodysOrder;
};

defineExpose({
  submitQuestion,
});
</script>

<style scoped lang="scss">
.toggle-switch-view {
  border-radius: 6px;
  background: var(--ui-white, #fff);
  backdrop-filter: blur(6px);
  // padding: 4px;
  align-items: center;
  display: inline-flex;

  label {
    margin-bottom: 0;
  }
  .label {
    display: flex;
    cursor: pointer;
    padding: 10px 18px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 0;
    color: var(--ui-light-grey, #b7b7b7);
    letter-spacing: 1px;
    border-radius: 6px;
    min-width: 16px;
  }

  input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;

    &:checked + .label {
      background: var(--brand-navy, #211f58);
      color: #fff;
    }
  }
  &.setting-option-selected {
    background: var(--brand-navy, #211f58);
  }
}

.assessmentQuestion {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eff0f1;
  background: #fff;
  width: 100%;
}
</style>
